module.exports = __webpack_public_path__ + "img/payment_8.c2f737ef.png";